import { useThunkDispatch } from './useThunkDispatch';

import { sendNotificationSubscriptions } from 'actions/productdetail/sharing';

type SendNotificationArgsType = Parameters<typeof sendNotificationSubscriptions>;

export function useStockNotifications() {
  const dispatch = useThunkDispatch();

  return (...args: SendNotificationArgsType) => dispatch(sendNotificationSubscriptions(...args));
}
